'use strict';

/**
 * doc.php's listing: the filter over its tool tracks.
 *
 * The listing is fully server-rendered, so this only hides bands already on
 * the page; without the bundle every tool and version still renders, and
 * html:not(.js) hides the filter itself. A band that stops matching dims
 * first and then leaves, so the reader sees what the keystroke removed.
 */

const LEAVE_MS = 160;

function initDocList() {
  const input = document.getElementById('dct-filter-input');
  const list = document.getElementById('dct-tools');
  if (!input || !list) return;

  const status = document.getElementById('dct-filter-status');
  const empty = document.getElementById('dct-empty');
  const reset = document.getElementById('dct-empty-reset');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  const tools = Array.from(list.querySelectorAll('.dct-tool')).map(el => ({
    el,
    haystack: el.dataset.search || '',
    timer: 0,
  }));
  const total = tools.length;
  const noun = n => (n === 1 ? 'tool' : 'tools');

  function show(tool, visible) {
    window.clearTimeout(tool.timer);
    if (visible) {
      tool.el.hidden = false;
      tool.el.classList.remove('is-leaving');
      return;
    }
    if (tool.el.hidden) return;
    if (still.matches) {
      tool.el.hidden = true;
      return;
    }
    tool.el.classList.add('is-leaving');
    tool.timer = window.setTimeout(() => {
      tool.el.hidden = true;
      tool.el.classList.remove('is-leaving');
    }, LEAVE_MS);
  }

  function apply() {
    const words = input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
    let visible = 0;
    tools.forEach(tool => {
      const match = words.every(w => tool.haystack.includes(w));
      show(tool, match);
      if (match) visible += 1;
    });

    if (empty) empty.hidden = visible !== 0;
    if (status) {
      status.textContent = words.length === 0
        ? ''
        : `${visible} of ${total} ${noun(total)} match.`;
    }
  }

  input.addEventListener('input', apply);

  // Escape clears, as type="search" does natively in some browsers only.
  input.addEventListener('keydown', e => {
    if (e.key === 'Escape' && input.value !== '') {
      input.value = '';
      apply();
    }
  });

  // "/" jumps to the filter from anywhere that is not already a text field.
  document.addEventListener('keydown', e => {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    const t = e.target;
    if (t instanceof HTMLElement && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    e.preventDefault();
    input.focus();
  });

  reset?.addEventListener('click', () => {
    input.value = '';
    apply();
    input.focus();
  });

  // A value the browser restored on back-navigation is applied, not ignored.
  if (input.value !== '') apply();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDocList);
} else {
  initDocList();
}
